/** Parse DRF / Django error bodies for investor-facing messages. */
export function formatApiDetail(err, fallback = "Something went wrong.") {
  const d = err?.response?.data;
  if (d == null) return err?.message || fallback;
  if (typeof d === "string") return d.trim() || fallback;
  if (typeof d.detail === "string") return d.detail;
  if (Array.isArray(d.detail) && d.detail[0]) return String(d.detail[0]);
  if (typeof d === "object") {
    const parts = [];
    for (const [k, v] of Object.entries(d)) {
      if (Array.isArray(v) && v[0]) parts.push(`${k}: ${typeof v[0] === "string" ? v[0] : JSON.stringify(v[0])}`);
      else if (typeof v === "string") parts.push(`${k}: ${v}`);
    }
    if (parts.length) return parts.join(" ");
  }
  return fallback;
}

function isRequestTimeoutOrUnreachable(err) {
  if (!err) return false;
  const code = String(err.code || "");
  const msg = String(err.message || "").toLowerCase();
  return (
    code === "ECONNABORTED" ||
    code === "ETIMEDOUT" ||
    code === "ERR_NETWORK" ||
    msg.includes("timeout") ||
    msg.includes("network error")
  );
}

/** Format API errors from POST /investments/transfer/ and transfer-preview for investor UI. */
export function formatTransferApiError(err) {
  if (isRequestTimeoutOrUnreachable(err)) {
    return "The server did not respond in time. Check that the API is running and reachable, then try again.";
  }
  if (!err?.response) {
    return "Could not reach the server. Check your connection and API URL, then try again.";
  }
  const d = err?.response?.data;
  if (d == null) return err?.message || "Transfer failed.";
  if (typeof d === "string") return d.trim();
  if (typeof d.detail === "string") return d.detail;
  if (Array.isArray(d.detail) && d.detail[0]) return String(d.detail[0]);
  if (d.to_investor_id?.[0]) return String(d.to_investor_id[0]);
  if (d.shares?.[0]) return String(d.shares[0]);
  if (d.non_field_errors?.[0]) return String(d.non_field_errors[0]);
  if (typeof d === "object") {
    const parts = [];
    for (const [k, v] of Object.entries(d)) {
      if (Array.isArray(v) && v[0]) parts.push(`${k}: ${typeof v[0] === "string" ? v[0] : JSON.stringify(v[0])}`);
      else if (typeof v === "string") parts.push(`${k}: ${v}`);
    }
    if (parts.length) return parts.join(" ");
  }
  return "Transfer failed.";
}
